package com.schoolconnect.app.feature.staff

import androidx.compose.runtime.Composable

@Composable
fun StaffScreen(
    state: StaffUiState,
    onEvent: (StaffUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    StaffContent(
        state = state,
        onEvent = onEvent,
        shellRoleCode = shellRoleCode,
        shellSchoolLabel = shellSchoolLabel,
        onChangeRole = onChangeRole,
        onLogout = onLogout
    )
}

